var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Paper, Snackbar, Fade, LinearProgress, Card, CardHeader, Divider, CardContent, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import { LiftChartSchema as defaultSchema } from '../../../entities';
import { useCreateChart, useChartConstruct, useDeleteChart } from '../../../hooks';
import ChartSelector from './ChartSelector';
import DimensionSelect from './DimensionSelect';
import DimensionChips from './DimensionChips';
import Lottie from '../Lottie';
import checkmark from '../../../animations/checkmark.json';
import errormark from '../../../animations/errormark.json';
import ChartContainer from '../ChartContainer/ChartContainer';
var useStyles = makeStyles({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    graphSelector: {
        flex: 1,
    },
    dimensionRadio: {
        flexGrow: 2,
    },
});
var ChartBuilder = function (_a) {
    var destination = _a.destination;
    var classes = useStyles();
    var _b = useChartConstruct(), chartConstruct = _b.chartConstruct, setChartConstruct = _b.setChartConstruct;
    var _c = useState(defaultSchema), chartSchema = _c[0], setChartSchema = _c[1];
    var _d = useState(false), isCreated = _d[0], setIsCreated = _d[1];
    var _e = useState(false), finishCreateAnimation = _e[0], setFinishCreateAnimation = _e[1];
    var _f = useState(false), finishDeleteAnimation = _f[0], setFinishDeleteAnimation = _f[1];
    var _g = useCreateChart(destination.id), chartData = _g.data, processing = _g.processing, createChart = _g.createChart, open = _g.open, setOpen = _g.setOpen;
    var _h = useDeleteChart(chartData === null || chartData === void 0 ? void 0 : chartData.createChart.id), deleteData = _h.data, processingDelete = _h.processing, openDelete = _h.open, deleteChart = _h.deleteChart, setDeleteOpen = _h.setOpen;
    useEffect(function () {
        if (open && !processing)
            setFinishCreateAnimation(true);
    }, [open, processing]);
    useEffect(function () {
        if (openDelete && !processingDelete)
            setFinishDeleteAnimation(true);
    }, [openDelete, processingDelete]);
    useEffect(function () {
        setChartConstruct(null);
    }, [chartSchema]);
    return (React.createElement(Container, null,
        React.createElement("h3", null, "Chart Builder"),
        React.createElement(Paper, { className: classes.root },
            React.createElement(Box, { className: classes.graphSelector },
                React.createElement(ChartSelector, { setChartSchema: setChartSchema })),
            React.createElement(Box, { className: classes.dimensionRadio }, destination && chartSchema.type ? (React.createElement(Box, { style: { display: 'flex', height: '100%', flexDirection: 'column' } }, Object.entries(chartSchema)
                .filter(function (_a) {
                var key = _a[0], value = _a[1];
                return key !== 'type';
            })
                .map(function (_a) {
                var _b;
                var key = _a[0], value = _a[1];
                return value.expansive ? (React.createElement(DimensionChips, { key: key, destination: destination, dimensionKey: key })) : ((_b = value.required) === null || _b === void 0 ? void 0 : _b.map(function (dimensionName, i) { return (React.createElement(DimensionSelect, { key: i, destination: destination, dimensionName: dimensionName, dimensionKey: key })); }));
            }))) : null),
            processing && React.createElement(LinearProgress, null)),
        React.createElement(Button, { variant: "contained", style: { float: 'right' }, color: "primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            //setPreviewInputs();
                            setIsCreated(true);
                            return [4 /*yield*/, createChart(chartSchema, chartConstruct)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); } }, "Create Chart"),
        React.createElement(Snackbar, { open: open, autoHideDuration: 1000, TransitionComponent: Fade, message: "Chart #" + (chartData === null || chartData === void 0 ? void 0 : chartData.createChart.id) + " Registered" }),
        React.createElement(Snackbar, { open: openDelete, autoHideDuration: 1000, TransitionComponent: Fade, message: "Chart #" + (chartData === null || chartData === void 0 ? void 0 : chartData.createChart.id) + " Deleted" }),
        finishCreateAnimation && (React.createElement(Lottie, { data: chartData ? checkmark : errormark, width: 36, height: 36, onEnd: function () {
                setOpen(false);
                setFinishCreateAnimation(false);
            } })),
        finishDeleteAnimation && (React.createElement(Lottie, { data: deleteData ? checkmark : errormark, width: 36, height: 36, onEnd: function () {
                setDeleteOpen(false);
                setFinishDeleteAnimation(false);
            } })),
        isCreated ? (React.createElement(Container, { style: { marginTop: 40, height: 400 } },
            React.createElement(Card, null,
                React.createElement(CardHeader, { action: React.createElement(Button, { onClick: function () {
                            deleteChart();
                            setIsCreated(false);
                        }, variant: "contained", color: "default", startIcon: React.createElement(DeleteIcon, null) }, "Delete Chart"), title: "Result" }),
                React.createElement(Divider, null),
                React.createElement(CardContent, null, chartData ? React.createElement(ChartContainer, { chartId: chartData.createChart.id }) : undefined)))) : null));
};
export default ChartBuilder;
